export enum CountryKeys {
  ID = "id",
  NAME = "name",
  IS_EU = "isEu",
  CURRENCY = "currency",
  CALLING_CODE = "callingCode",
  COUNTRY_CODE = "countryCode",
  DEFAULT_CURRENCY_CODE = "defaultCurrencyCode",
}
